var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartOv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1448_41553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5624 22.9264C45.5624 35.0294 35.6489 44.8499 23.4086 44.8499C11.1684 44.8499 1.25492 35.0294 1.25492 22.9264C1.25492 10.8235 11.1684 1.00297 23.4086 1.00297C35.6489 1.00297 45.5624 10.8235 45.5624 22.9264Z",
    fill: "#27AB60",
    stroke: "white",
    strokeWidth: 1.05281
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1448_41553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0402 16.326H21.6424C21.0073 16.326 20.5764 16.7525 20.5764 17.3811C20.5764 18.0097 21.0073 18.4362 21.6424 18.4362H27.1536C28.6278 18.4362 29.8979 19.6934 29.8979 21.1527V25.0365C29.8979 26.4957 28.6278 27.7529 27.1536 27.7529H21.6424C20.3723 27.7529 19.3063 26.9223 18.9888 25.7549L16.9703 18.8403L15.5868 13.9238C15.1785 12.7564 14.1126 11.9258 12.8425 11.9258H10.3023C9.66725 11.9258 9.23633 12.3523 9.23633 12.9809C9.23633 13.6095 9.66725 14.0361 10.3023 14.0361H12.8425C13.16 14.0361 13.4775 14.2381 13.5909 14.5524L15.0651 19.3791L16.9703 26.4059C17.4919 28.4938 19.5104 29.9755 21.6424 29.9755H27.0402C29.6938 29.9755 31.9165 27.7754 31.9165 25.1488V21.2425C31.9165 18.526 29.8072 16.326 27.0402 16.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3739 31.8359H19.5347C18.8997 31.8359 18.4688 32.2625 18.4688 32.8911C18.4688 33.5197 18.8997 33.9462 19.5347 33.9462H20.3739C21.0089 33.9462 21.4398 33.5197 21.4398 32.8911C21.4172 32.24 21.0089 31.8359 20.3739 31.8359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8973 31.8359H29.0582C28.4231 31.8359 27.9922 32.2625 27.9922 32.8911C27.9922 33.5197 28.4231 33.9462 29.0582 33.9462H29.8973C30.5324 33.9462 30.9633 33.5197 30.9633 32.8911C30.9633 32.24 30.5324 31.8359 29.8973 31.8359Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1448_41553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.3603,
    height: 44.8997,
    fill: "white",
    transform: "translate(0.726562 0.476562)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1448_41553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.6801,
    height: 22.4499,
    fill: "white",
    transform: "translate(9.23242 11.7031)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartOv);
export default __webpack_public_path__ + "static/media/cartOv.71883fd4620a5a7c23badcdaf5a34ccc.svg";
export { ForwardRef as ReactComponent };